import React from 'react';
import { Recorder } from 'containers';

const RecordingPage = (props) => {
  return (
    <Recorder {...props}></Recorder>
  )
}

export default RecordingPage
